import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { FileService } from '../../../services/file.service';
import { SubmitService } from '../../../services/submit.service';

import { EditorStyle, FormatterData, InstallationFlowType, MessageType, QuillConfig } from '../../../constants/app.constants';
import { DateFormat, ExampleDocument, ExampleDocumentResponse, KeyValueData } from '../../../domains/common.domain';
import { CommunicationService } from '../../../services/communication.service';
import { ErrorService } from '../../../services/error/error.service';
import { LocalStorageService } from '../../../services/local-storage.service';

import { AllDropdownKeys, UrlSegments } from '../../../jurisdiction/jurisdiction.constants';
import {
  ChimneySweeper,
  ContactPerson,
  Document,
  DocumentResponse,
  GetChimneySweeperResponse,
  LookupOptionsData,
  UpdateApplicationStatusRequest,
  UpdateApplicationStatusResponse,
} from '../../../jurisdiction/jurisdiction.domain';
import { SubmissionFormData } from './documents-submission.domain';
import {
  GetInstallationApplicationObject,
  InstallationApplicationData,
  PowerMeterData,
} from '../../../jurisdiction/facilities-form/facilities-form.domain';
import {
  GetGridConnectionObject,
  GridConnectionData,
  PowerSpecialConsumerData,
} from '../../../jurisdiction/technician-data/technician-data.domain';
import { FacilitiesFormService } from '../../../jurisdiction/facilities-form/facilities-form.service';
import { concatMap } from 'rxjs/operators';
import { EnvironmentService } from '../../../services/environment.service';
import { DownloadCenterService } from '../../../services/download-center.service';
import { JurisdictionService } from '../../../jurisdiction/jurisdiction.service';
import { ComponentCanDeactivate } from 'src/app/+shared/guards/pending-changes-guard.servie';
import { GridApplicationDocumentTypes } from 'src/app/+grid-application-shared/entities/enums/grid-application-document-types.enum';
import { ContactPersonComponent } from 'src/app/+shared/components/contact-person/contact-person.component';
import { SectionIdentifier } from 'src/app/+shared/components/review-section/review-section.domain';
import { DrrCcdDeviceApplicationDto, DrrCcdDocumentTypes } from 'src/app/+drr-ccd-devices/technical-data/technical-data.domain';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { DrrCcdDeviceService } from 'src/app/+drr-ccd-devices/technical-data/technical-data.service';
import { ReviewSectionComponent } from '../review-section/review-section.component';
import { UserService } from 'src/app/services/user.service';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
  providers: [FacilitiesFormService],
  selector: 'app-documents-submission',
  templateUrl: './documents-submission.component.html',
  styleUrls: ['./documents-submission.component.scss'],
})
export class DocumentsSubmissionComponent extends DestroyableComponent implements OnInit, ComponentCanDeactivate, AfterViewInit {
  @Input() isDetailsView: boolean;
  @Input() showNavSteps: boolean = true;
  @Input() showInquiry: boolean = true;
  @Input() showSubmitButton: boolean = true;
  @Input() drrCcdDeviceApplicationDto: DrrCcdDeviceApplicationDto;

  @Output() onDocumentFormInit = new EventEmitter<FormGroup>();
  @ViewChild(QuillEditorComponent) editor1!: QuillEditorComponent;
  @ViewChild(QuillEditorComponent) editor2!: QuillEditorComponent;

  allSampleDocuments: {
    [key: string]: ExampleDocument;
  };
  applicationData: InstallationApplicationData | GridConnectionData | DrrCcdDeviceApplicationDto;
  dateFormat: DateFormat;
  documents: FormGroup;
  items: FormArray;
  formData: SubmissionFormData;
  selectedDate: string | Date;
  connectionDate: string | Date;
  currentInstallationFlow: string;
  infoBubblesData: {
    [key: string]: boolean;
  };
  installationFlowType: KeyValueData;
  documentIds: string[];
  existingDocuments: Document[];
  documentTypeKey: string;
  documentTypes: LookupOptionsData[];
  chimneySweeperOptions: ChimneySweeper[];
  minDate: Date;
  minBuildingConDate: Date;
  isLoading: boolean;
  isReadOnly: boolean;
  isAllMediaFacilityAvailable: boolean;
  isPowerFacilityAvailable: boolean;
  isGasFacilityAvailable: boolean;
  isWaterFacilityAvailable: boolean;
  isHeatingFacilityAvailable: boolean;
  powerTermsChecked: boolean;
  technicalConditionsMetCheckbox: boolean;
  acceptOfferCheckbox: boolean;
  gasTermsChecked1: boolean;
  gasTermsChecked2: boolean;
  gasTermsChecked3: boolean;
  waterTermsChecked: boolean;
  heatingTermsChecked: boolean;
  isBasementAvailable: boolean;
  isSubmitDisabled: boolean;
  currentSelectionType: string;
  editorStyle: any;
  quillConfig: any;
  isGridCompatibility: boolean;
  districtHeatingRegulationsChecked: boolean;
  gridConnectionContractCheckbox: boolean;
  isVerifiedByTechnician: boolean;
  buildingIsClosedCheckbox: boolean;
  freedomToBuildCheckbox: boolean;
  sewageAndRainwaterClosureCheckbox: boolean;
  houseEntriesCheckbox: boolean;
  correctnessOfInformationCheckbox: boolean;
  powerConnectionInstallationLocationType: string = undefined;
  // show fields
  showHelpText: boolean;
  showInstallationComment: boolean;
  showDistrictHeatingRegulationsCheckbox: boolean;
  showCommentField: boolean;
  showPowerTermsChecked: boolean;
  showTechnicalConditionsMetCheckbox: boolean;
  showInquiryDesiredDate: boolean;
  showMainsConnectionApproval: boolean;
  showConnectionDateSelector: boolean;
  showAddMoreProductsButton: boolean;
  showSampleDocuments: boolean;
  showExcerptOrOverviewPlanDocument: boolean;
  showCorrectnessOfInformationCheckbox: boolean;
  showWorksBeginsAfterOfferLable: boolean;
  showManufacturerSheets: boolean = !this.environmentService.hideManufacturerSheets;
  showManufacturerGenerationSheet: boolean = !this.environmentService.hideManufacturerGenerationSheet;
  showSinglePoleOverviewPlan: boolean = !this.environmentService.hideSinglePoleOverviewPlan;
  showSitePlanLabel: boolean = this.environmentService.showSitePlanLabel;
  showNoteFindRelevantDocsChecklist: boolean = this.environmentService.showNoteFindRelevantDocsChecklist;
  showNoteIfStorageIsSelected: boolean = this.environmentService.showNoteIfStorageIsSelected;
  showAcceptOfferCheckbox: boolean = this.environmentService.showAcceptOfferCheckbox;
  // required fields
  isSiteElectricityRequired: boolean;
  floorPlanDocumentRequired: boolean;
  requiredUnitCertificateDocument: boolean = this.environmentService.requiredUnitCertificateDocument;
  requiredNaProtectionCertificateDocument: boolean = this.environmentService.requiredNaProtectionCertificateDocument;
  requiredVdeDocument: boolean = this.environmentService.requiredVdeDocument;
  requiredOverviewPlanSinglePoleDocument: boolean = this.environmentService.requiredOverviewPlanSinglePoleDocument;
  showPlanWithEntryForConversionToGas: boolean = this.environmentService.showPlanWithEntryForConversionToGas;
  showSitePlanDocumentForConversionToGas: boolean = this.environmentService.showSitePlanDocumentForConversionToGas;
  showContactPersonOnDocumentsPage: boolean = this.environmentService.showContactPersonOnDocumentsPage;
  selectedDateDisabledDays = this.environmentService.desiredDateDisabledDays;

  role: string;
  preventCanDeactivate: boolean = false;
  SectionIdentifier = SectionIdentifier;
  maxCommentLength = 800;

  private feedInAltConceptChecked: boolean = false;
  private documentsConfig = this.environmentService.documentsForFeedInSystem;
  show = {
    site_plan: !!this.documentsConfig?.site_plan?.show,
    unit_certificate: !!this.documentsConfig?.unit_certificate?.show,
    na_protection_certificate: !!this.documentsConfig?.na_protection_certificate?.show,
    vde_documents: !!this.documentsConfig?.vde_documents?.show,
    data_sheet_modules: !!this.documentsConfig?.data_sheet_modules?.show,
    data_sheet_generating_unit: !!this.documentsConfig?.data_sheet_generating_unit?.show,
    overview_plan_single_pole: !!this.documentsConfig?.overview_plan_single_pole?.show,
    pole_circuit_diagram_1: !!this.documentsConfig?.pole_circuit_diagram_1?.show,
    power_of_attorney_1: !!this.documentsConfig?.power_of_attorney_1?.show,
    e_1_application: !!this.documentsConfig?.e_1_application?.show,
    e_2_data_sheet: !!this.documentsConfig?.e_2_data_sheet?.show,
    e_3_memory_data: !!this.documentsConfig?.e_3_memory_data?.show,
    e_4_uniform_certificate: !!this.documentsConfig?.e_4_uniform_certificate?.show,
    e_6_certificate_for_network: !!this.documentsConfig?.e_6_certificate_for_network?.show,
    e_7_requirements_for_test_report: !!this.documentsConfig?.e_7_requirements_for_test_report?.show,
    b_11_overview_circuit_diagram: !!this.documentsConfig?.b_11_overview_circuit_diagram?.show,
    registration_for_network_connection: !!this.documentsConfig?.registration_for_network_connection?.show,
    site_plan_or_area_map: !!this.documentsConfig?.site_plan_or_area_map?.show,
    proof_of_conformity_certificates_modules: !!this.documentsConfig?.proof_of_conformity_certificates_modules?.show,
    proof_of_conformity_certificates_storage: !!this.documentsConfig?.proof_of_conformity_certificates_storage?.show,
    measuring_concept: !!this.documentsConfig?.measuring_concept?.show,
    e_5_test_report: !!this.documentsConfig?.e_5_test_report?.show,
    e_8_commissioning_protocol: !!this.documentsConfig?.e_8_commissioning_protocol?.show,
    ground_protocol: !!this.documentsConfig?.ground_protocol?.show,
  };

  required = {
    site_plan: !!this.documentsConfig?.site_plan?.required,
    unit_certificate: !!this.documentsConfig?.unit_certificate?.required,
    na_protection_certificate: !!this.documentsConfig?.na_protection_certificate?.required,
    vde_documents: !!this.documentsConfig?.vde_documents?.required,
    data_sheet_modules: !!this.documentsConfig?.data_sheet_modules?.required,
    data_sheet_generating_unit: !!this.documentsConfig?.data_sheet_generating_unit?.required,
    overview_plan_single_pole: !!this.documentsConfig?.overview_plan_single_pole?.required,
    pole_circuit_diagram_1: !!this.documentsConfig?.pole_circuit_diagram_1?.required,
    power_of_attorney_1: !!this.documentsConfig?.power_of_attorney_1?.required,
    e_1_application: !!this.documentsConfig?.e_1_application?.required,
    e_2_data_sheet: !!this.documentsConfig?.e_2_data_sheet?.required,
    e_3_memory_data: !!this.documentsConfig?.e_3_memory_data?.required,
    e_4_uniform_certificate: !!this.documentsConfig?.e_4_uniform_certificate?.required,
    e_6_certificate_for_network: !!this.documentsConfig?.e_6_certificate_for_network?.required,
    e_7_requirements_for_test_report: !!this.documentsConfig?.e_7_requirements_for_test_report?.required,
    b_11_overview_circuit_diagram: !!this.documentsConfig?.b_11_overview_circuit_diagram?.required,
    registration_for_network_connection: !!this.documentsConfig?.registration_for_network_connection?.required,
    site_plan_or_area_map: !!this.documentsConfig?.site_plan_or_area_map?.required,
    proof_of_conformity_certificates_modules: !!this.documentsConfig?.proof_of_conformity_certificates_modules?.required,
    proof_of_conformity_certificates_storage: !!this.documentsConfig?.proof_of_conformity_certificates_storage?.required,
    measuring_concept: !!this.documentsConfig?.measuring_concept?.required,
    e_5_test_report: !!this.documentsConfig?.e_5_test_report?.required,
    e_8_commissioning_protocol: !!this.documentsConfig?.e_8_commissioning_protocol?.required,
    ground_protocol: !!this.documentsConfig?.ground_protocol?.required,
  };

  powerConsumerDocumentDetails: any[] = [];
  gridApplicationDocumentTypes = GridApplicationDocumentTypes;
  drrCcdApplicationDocumentTypes = DrrCcdDocumentTypes;

  private connectionInstallationDocumentsConfig = this.environmentService.documentsForConnectionInstallation;
  connectionInstallationDocuments = {
    hideSitePlan: this.connectionInstallationDocumentsConfig.hide_site_plan,
  };
  contactPersonData: ContactPerson;

  get hideMandatoryDocuments(): boolean {
    const selectedChangeType = JSON.parse(localStorage.getItem('selected_change_type'));

    if (selectedChangeType) {
      return this.environmentService.hideMandatoryDocuments && (selectedChangeType === 'shutdown' || selectedChangeType === 'reinforce');
    }
    return false;
  }

  get showNoteUploadAltMeasurementDoc(): boolean {
    return (
      this.currentInstallationFlow === this.installationFlowType.FeedInSystem &&
      this.environmentService.showNoteUploadAltMeasurementDoc &&
      this.feedInAltConceptChecked
    );
  }

  get showUploadAltMeasuringConcept(): boolean {
    return this.currentInstallationFlow === this.installationFlowType.FeedInSystem && this.feedInAltConceptChecked;
  }

  get isSitePlanDocumentVisible(): boolean {
    return (
      (this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
        this.currentInstallationFlow === this.installationFlowType.TemporaryConnection ||
        this.currentInstallationFlow === this.installationFlowType.ChangeHouseConnection ||
        this.currentInstallationFlow === this.installationFlowType.SiteElectricityMeterdata) &&
      !this.hideMandatoryDocuments
    );
  }

  get isFloorPlanDocumentVisible(): boolean {
    return (
      (this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
        this.currentInstallationFlow === this.installationFlowType.ChangeHouseConnection) &&
      !this.hideMandatoryDocuments
    );
  }

  get isCustomerPowerAttorneyVisible(): boolean {
    return this.environmentService.showCustomerPowerOfAttorney && !this.hideMandatoryDocuments;
  }

  get isTechnician(): boolean {
    return this.userService.isUserTechnicianRole();
  }

  constructor(
    private communicationService: CommunicationService,
    private errorService: ErrorService,
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
    private fileService: FileService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private submitService: SubmitService,
    private facilitiesFormService: FacilitiesFormService,
    public environmentService: EnvironmentService,
    private downloadCenterService: DownloadCenterService,
    private jurisdictionService: JurisdictionService,
    private drrCcdDeviceService: DrrCcdDeviceService,
    private cd: ChangeDetectorRef,
    private userService: UserService
  ) {
    super();
  }

  @ViewChild('contactPerson') contactPersonComponent: ContactPersonComponent;
  @ViewChild('documentsSection') documentsSection: ReviewSectionComponent;
  @ViewChild('inquirySection') inquirySection: ReviewSectionComponent;

  canDeactivate(): boolean | Promise<boolean> {
    return this.preventCanDeactivate;
  }

  ngOnInit(): void {
    this.installationFlowType = InstallationFlowType;
    this.currentInstallationFlow = this.localStorageService.getItem('installation_flow') || '';
    this.isGridCompatibility = this.currentInstallationFlow === 'gridCompatibility';
    this.formData = this.localStorageService.getItem('documents_data') || {};
    this.currentSelectionType = this.localStorageService.getItem('selected_change_type');
    this.dateFormat = FormatterData.date;
    this.documentTypeKey = AllDropdownKeys.DocumentType;
    this.documentTypes = [...this.commonService.getDropdownData(this.documentTypeKey)];
    this.documentIds = [];
    this.existingDocuments = [];
    this.isLoading = false;
    this.isReadOnly = this.route.snapshot.queryParamMap.get('isReadOnly') === 'true';
    this.showAddMoreProductsButton = this.environmentService.showAddMoreProductsButton[this.currentInstallationFlow];
    this.showSampleDocuments = this.environmentService.sampleDocuments;
    this.allSampleDocuments = null;
    this.infoBubblesData = this.environmentService.getInfoBubblesData('documentSubmission') || null;
    this.floorPlanDocumentRequired =
      this.environmentService.floorPlanDocumentRequiredForTemporaryHouse ||
      (this.currentInstallationFlow !== this.installationFlowType.TemporaryConnection &&
        !this.environmentService.floorPlanDocumentRequiredForTemporaryHouse);
    this.showCommentField = this.environmentService.showCommentField;
    this.showPowerTermsChecked = this.environmentService.showPowerTermsChecked;
    this.showTechnicalConditionsMetCheckbox = this.environmentService.showTechnicalConditionsMetCheckbox;
    this.showInquiryDesiredDate = this.environmentService.showInquiryDesiredDate;
    this.showMainsConnectionApproval = this.environmentService.showMainsConnectionApproval;
    this.showDistrictHeatingRegulationsCheckbox = this.environmentService.showDistrictHeatingRegulationsCheckbox;
    this.showHelpText = this.environmentService.showHelpText;
    this.showExcerptOrOverviewPlanDocument = this.environmentService.showExcerptOrOverviewPlanDocument;
    this.showCorrectnessOfInformationCheckbox = this.environmentService.showCorrectnessOfInformationCheckbox;
    this.showWorksBeginsAfterOfferLable = this.environmentService.showWorksBeginsAfterOfferLable;

    const facilityTypes = this.localStorageService.getItem('selected_facilities') || [];
    this.isAllMediaFacilityAvailable =
      facilityTypes.findIndex(
        facility => facility.key === 'power' || facility.key === 'water' || facility.key === 'gas' || facility.key === 'heating'
      ) > -1;
    this.isPowerFacilityAvailable = facilityTypes.findIndex(facility => facility.key === 'power') > -1;
    this.isGasFacilityAvailable = facilityTypes.findIndex(facility => facility.key === 'gas') > -1;
    this.isWaterFacilityAvailable = facilityTypes.findIndex(facility => facility.key === 'water') > -1;
    this.isHeatingFacilityAvailable = facilityTypes.findIndex(facility => facility.key === 'heating') > -1;

    this.showInstallationComment =
      this.environmentService.showAdditionalComment &&
      [InstallationFlowType.NewInstallation, InstallationFlowType.UpdateInstallation].indexOf(this.currentInstallationFlow) > -1 &&
      this.isPowerFacilityAvailable;
    this.isSubmitDisabled = true;
    this.powerTermsChecked = this.isDetailsView ? true : false;
    this.technicalConditionsMetCheckbox = false;
    this.acceptOfferCheckbox = false;
    this.gasTermsChecked1 = false;
    this.gasTermsChecked2 = false;
    this.gasTermsChecked3 = !this.environmentService.showGas3;
    this.waterTermsChecked = false;
    this.heatingTermsChecked = false;
    this.isSiteElectricityRequired = this.localStorageService.getItem('site_electricity_required') || false;
    this.isBasementAvailable = false;
    this.role = this.localStorageService.getItem('role');

    if (
      this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
      this.currentInstallationFlow === this.installationFlowType.ChangeHouseConnection
    ) {
      this.showConnectionDateSelector =
        this.commonService.gridConnectionApplicationData && this.commonService.gridConnectionApplicationData.site_power_required === '1';
      this.isBasementAvailable = this.commonService.gridConnectionApplicationData?.ffb_basement_available === '1';
    } else {
      this.showConnectionDateSelector = false;
    }

    if (
      this.currentInstallationFlow === this.installationFlowType.NewInstallation ||
      this.currentInstallationFlow === this.installationFlowType.UpdateInstallation ||
      this.currentInstallationFlow === this.installationFlowType.FeedInSystem ||
      this.currentInstallationFlow === this.installationFlowType.SiteElectricityMeterdata
    ) {
      this.getInstallationApplication();
      if (this.currentInstallationFlow === this.installationFlowType.FeedInSystem && this.environmentService.showSampleDocumentsForFeedIn) {
        this.displaySampleDocuments();
      }
    } else if (
      this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
      this.currentInstallationFlow === this.installationFlowType.TemporaryConnection ||
      this.currentInstallationFlow === this.installationFlowType.ChangeHouseConnection ||
      this.currentInstallationFlow === this.installationFlowType.ConversionToGas
    ) {
      this.getGridConnectionApplicationData();

      if (this.showSampleDocuments) {
        this.displaySampleDocuments();
      }
    } else if (this.currentInstallationFlow === this.installationFlowType.ConsumptionDevices) {
      this.getDrrCcdApplication();
      this.showInstallationComment = true;
      this.showCommentField = true;
    }

    if (this.environmentService.showWordFormat) {
      this.editorStyle = EditorStyle;
      this.quillConfig = QuillConfig;
    }

    this.initialiseDates();
    this.setMandatoryCheckboxes();
  }

  rebuildComponent(installationLocationType = undefined) {
    this.powerConnectionInstallationLocationType = installationLocationType;
    this.ngOnInit();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.editor1?.quillEditor.on('text-change', (delta, oldDelta, source) => {
        if (source === 'user') {
          // Get full HTML content including tags and styles
          const htmlContent = this.getEscapedHtml(this.editor1?.quillEditor.root.innerHTML);

          // If exceeding max length, revert to previous state
          if (htmlContent.length >= this.maxCommentLength) {
            this.editor1?.quillEditor.setContents(oldDelta);
            this.errorService.showError('Maximum characters reached!', 5000);
          }
        }
      });
      this.editor2?.quillEditor.on('text-change', (delta, oldDelta, source) => {
        if (source === 'user') {
          // Get full HTML content including tags and styles
          const htmlContent = this.getEscapedHtml(this.editor2?.quillEditor.root.innerHTML);

          // If exceeding max length, revert to previous state
          if (htmlContent.length >= this.maxCommentLength) {
            this.editor2?.quillEditor.setContents(oldDelta);
            this.errorService.showError('Maximum characters reached!', 5000);
          }
        }
      });
    }, 500);
  }

  private getEscapedHtml(htmlContent: string): string {
    // Use JSON.stringify to get the actual escaped string length
    // Remove the surrounding quotes that JSON.stringify adds
    const escapedString = JSON.stringify(htmlContent);
    return escapedString.slice(1, -1); // Remove first and last quote
  }

  get showDesiredDateOperationInfo(): boolean {
    const facilityTypes = this.localStorageService.getItem('selected_facilities') || [];
    const isMediaTypeAvailable = facilityTypes.some(
      facility => facility.key === 'power' || facility.key === 'water' || facility.key === 'gas'
    );
    return (
      this.environmentService.showDesiredDateOperationInfo &&
      [this.installationFlowType.NewInstallation, this.installationFlowType.UpdateInstallation].includes(this.currentInstallationFlow) &&
      isMediaTypeAvailable
    );
  }

  getInstallationApplication(): void {
    this.isLoading = true;

    this.facilitiesFormService.getInstallationApplication().subscribe(
      (response: GetInstallationApplicationObject) => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(response, true);
        this.applicationData = response.installationapplication[0];
        this.commonService.installationApplicationData = response.installationapplication[0];

        this.existingDocuments = this.applicationData.document?.filter(
          d => d.sk_document_type !== GridApplicationDocumentTypes.PowerOfAttorney
        );
        this.feedInAltConceptChecked = this.applicationData.feedininstallation?.alternative_measuring_concept === '1';
        this.contactPersonData = this.applicationData.contact_person;
        this.prepareDocumentsForm('installation');
        if (this.documents.get('comments')) {
          this.documents.controls.comments.setValue(this.applicationData.comment || '-');
        }
        if (this.documents.get('installationComment')) {
          this.documents.controls.installationComment.setValue(this.applicationData.installation_comment || '-');
        }
        this.selectedDate = this.applicationData.desired_date ? new Date(this.applicationData.desired_date) : null;
        this.connectionDate = this.applicationData.building_con_from ? new Date(this.applicationData.building_con_from) : null;
      },
      error => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  getGridConnectionApplicationData(): void {
    this.isLoading = true;
    const applicationId = this.localStorageService.getItem('application_id');
    this.commonService.getGridConnectionApplication(applicationId).subscribe(
      (response: GetGridConnectionObject) => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(response, true);
        this.applicationData = response.gridconapplication[0];
        this.commonService.gridConnectionApplicationData = response.gridconapplication[0];

        this.existingDocuments = this.applicationData.document?.filter(
          d => d.sk_document_type !== GridApplicationDocumentTypes.PowerOfAttorney
        );
        this.prepareDocumentsForm('connection');
        this.contactPersonData = this.applicationData.contact_person;
        if (this.documents.get('comments')) {
          this.documents.controls.comments.setValue(this.commonService.gridConnectionApplicationData.comment || '-');
        }
        this.selectedDate = this.applicationData.desired_date ? new Date(this.applicationData.desired_date) : null;
        this.connectionDate = this.applicationData.building_con_from ? new Date(this.applicationData.building_con_from) : null;
      },
      error => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  getDrrCcdApplication() {
    const drrCcdDeviceApplicationDto = this.drrCcdDeviceApplicationDto;
    this.applicationData = drrCcdDeviceApplicationDto;
    this.existingDocuments = drrCcdDeviceApplicationDto.document?.filter(
      d => d.sk_document_type !== GridApplicationDocumentTypes.PowerOfAttorney
    );
    this.prepareDocumentsForm('drrCcd');
    // this.commonService.gridConnectionApplicationData = response;
    this.contactPersonData = drrCcdDeviceApplicationDto.contact_person;
    if (this.documents.get('comments')) {
      this.documents.controls.comments.setValue(this.applicationData.comment);
    }
    if (this.documents.get('installationComment')) {
      this.documents.controls.installationComment.setValue(this.applicationData.installation_comment || '-');
    }
    this.selectedDate = this.applicationData.desired_date ? new Date(this.applicationData.desired_date) : null;
    this.connectionDate = this.applicationData.building_con_from ? new Date(this.applicationData.building_con_from) : null;
  }

  addDocuments(newDocument: boolean = false): void {
    if (!newDocument && this.formData && this.formData.documents && this.formData.documents.length) {
      this.formData.documents.forEach(dataObj => {
        this.addForm(dataObj);
      });
    } else {
      this.addForm();
    }
  }

  addForm(data?: any): void {
    this.items.push(
      this.formBuilder.group({
        documentName: (data && data.documentName) || '',
        fileName: (data && data.fileName) || '',
      })
    );
  }

  onImageUpload(event, index: number, uploader): void {
    const applicationId = this.localStorageService.getItem('application_id');
    const name = (this.items.controls[index] as FormGroup).value.documentName;
    if (this.documentIds[index] !== undefined) {
      this.fileService.modifyDocumentForWorkflow(event, this.documentIds[index]).subscribe(
        (response: any) => {
          uploader.clear();
          (this.items.controls[index] as FormGroup).controls.fileName.setValue(
            event.currentFiles && event.currentFiles[0] && event.currentFiles[0].name
          );
          this.errorService.throwErrorIfFailure(response, true);
        },
        error => {
          uploader.clear();
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    } else {
      this.fileService.uploadDocumentsForWorkflows(event, applicationId, 'other', name).subscribe(
        (response: DocumentResponse) => {
          (this.items.controls[index] as FormGroup).controls.fileName.setValue(
            event.currentFiles && event.currentFiles[0] && event.currentFiles[0].name
          );
          this.documentIds[index] = response.document[0].document_id;
          uploader.clear();
          this.errorService.throwErrorIfFailure(response, true);
          this.items.controls[index]?.disable();
        },
        error => {
          this.errorService.throwErrorIfFailure(error, true);
          uploader.clear();
        }
      );
    }
  }

  onSelectFile(event: any, documentType: string, uploader: any, controlName: string) {
    const applicationId = this.localStorageService.getItem('application_id');

    if (this.documents.get(controlName).value !== '') {
      this.fileService.modifyDocumentForWorkflow(event, this.documentIds[controlName]).subscribe(
        (response: any) => {
          uploader.clear();
          this.documents.controls[controlName].setValue(event.currentFiles[0].name);
          this.errorService.throwErrorIfFailure(response, true);
        },
        error => {
          uploader.clear();
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    } else {
      this.fileService.uploadDocumentsForWorkflows(event, applicationId, documentType, controlName).subscribe(
        (response: DocumentResponse) => {
          uploader.clear();
          this.documents.controls[controlName].setValue(event.currentFiles[0].name);
          this.documentIds[controlName] = response.document[0].document_id;
          this.errorService.throwErrorIfFailure(response, true);
        },
        error => {
          this.errorService.throwErrorIfFailure(error, true);
          uploader.clear();
        }
      );
    }
  }

  removeDocument(id: number): void {
    if (this.documentIds[id] !== undefined) {
      this.fileService.removeWorkflowDocument(this.documentIds[id], { skipHistoryLog: true }).subscribe(
        response => {
          this.items.removeAt(id);
          this.documentIds.splice(id, 1);
          this.errorService.throwErrorIfFailure(response, true);
        },
        error => {
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    } else {
      this.items.removeAt(id);
    }
  }

  downloadDocument(id: number, fileName: string): void {
    this.fileService.readWorkflowDocument(this.documentIds[id]).subscribe((response: Blob) => {
      this.fileService.downloadDocument(response, fileName);
    });
  }

  downloadExampleDocument(id: string, fileName: string): void {
    this.downloadCenterService.getExampleDocumentById(id).subscribe(
      response => {
        this.errorService.throwErrorIfFailure(response, true);
        this.downloadCenterService.downloadDocument(response, fileName);
      },
      error => {
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  getChimneySweeperDetails() {
    this.communicationService.getData('chimneysweeper').subscribe(
      (response: GetChimneySweeperResponse) => {
        this.errorService.throwErrorIfFailure(response, true);
        this.chimneySweeperOptions = response.chimneysweeper;
        this.documents.addControl('chimneySweep', new FormControl('', [Validators.required]));
      },
      error => {
        this.errorService.throwErrorIfFailure(error);
      }
    );
  }

  submitFormData(addMore: boolean): void {
    const data = {
      documents: this.items?.value ?? [],
      expectedDate: this.selectedDate,
    };
    this.isLoading = true;
    this.localStorageService.setItem('documents_data', data);
    if (
      this.isGasFacilityAvailable &&
      (this.currentInstallationFlow === this.installationFlowType.NewInstallation ||
        this.currentInstallationFlow === this.installationFlowType.UpdateInstallation)
    ) {
      const gasInstallationId = this.isGasFacilityAvailable
        ? (this.applicationData as InstallationApplicationData).gasinstallation.installation_id
        : '';

      const gasInstallationRequestUrl = `${UrlSegments.UpdateGasInstallation}=${gasInstallationId}`;
      const requestData = {
        confirm_chimneysweeper_report: this.gasTermsChecked3 ? '1' : '0',
        confirm_g600: this.gasTermsChecked2 ? '1' : '0',
        confirm_ndav: this.gasTermsChecked1 ? '1' : '0',
      };

      const subscription = this.facilitiesFormService.updateData(gasInstallationRequestUrl, requestData);

      subscription.pipe(concatMap(() => this.updateApplication())).subscribe(
        (response: UpdateApplicationStatusResponse) => {
          this.handleSuccessResponse(addMore, response);
        },
        error => {
          this.handleErrorResponse(error);
        }
      );
    } else {
      this.updateApplication().subscribe(
        (response: UpdateApplicationStatusResponse) => {
          this.handleSuccessResponse(addMore, response);
        },
        error => {
          this.handleErrorResponse(error);
        }
      );
    }

    this.preventCanDeactivate = true;
  }

  isFormInvalid(): boolean {
    let formValid = true;
    const controlsKeys = Object.keys(this.documents.controls);
    for (const key of controlsKeys) {
      if (key !== 'comments') {
        if (
          this.documents.controls[key].validator &&
          (this.documents.controls[key].value === '' || this.documents.controls[key].value === undefined)
        ) {
          formValid = false;
          break;
        }
      }
    }

    if (this.documents.controls?.contactPerson && this.documents.controls.contactPerson.invalid) {
      return true;
    }

    if (formValid) {
      if (this.currentInstallationFlow === this.installationFlowType.NewInstallation) {
        return (
          (this.isPowerFacilityAvailable && !this.powerTermsChecked) ||
          (this.isWaterFacilityAvailable && !this.waterTermsChecked) ||
          (this.isHeatingFacilityAvailable && !this.heatingTermsChecked) ||
          (this.isGasFacilityAvailable && (!this.gasTermsChecked1 || !this.gasTermsChecked2 || !this.gasTermsChecked3))
        );
      }
      if (this.currentInstallationFlow === this.installationFlowType.SiteElectricityMeterdata) {
        return !(this.isPowerFacilityAvailable && this.powerTermsChecked);
      }
      if (this.currentInstallationFlow === this.installationFlowType.UpdateInstallation) {
        return (
          (this.showPowerTermsChecked && this.isPowerFacilityAvailable && !this.powerTermsChecked) ||
          (!this.environmentService.hideGasConfirmationCheckboxes &&
            this.isGasFacilityAvailable &&
            (!this.gasTermsChecked1 || !this.gasTermsChecked2 || !this.gasTermsChecked3))
        );
      }
      if (
        this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
        this.currentInstallationFlow === this.installationFlowType.ChangeHouseConnection
      ) {
        return (
          (this.isHeatingFacilityAvailable && this.showDistrictHeatingRegulationsCheckbox && !this.districtHeatingRegulationsChecked) ||
          (this.showTechnicalConditionsMetCheckbox
            ? !this.technicalConditionsMetCheckbox
            : !this.isMainsConnectionApprovalValid() || !this.isCorrectnessOfInformationValid()) ||
          (this.currentInstallationFlow === this.installationFlowType.MainsConnection &&
            this.showAcceptOfferCheckbox &&
            !this.acceptOfferCheckbox)
        );
      }
      if (this.currentInstallationFlow === this.installationFlowType.ConversionToGas) {
        return !this.isCorrectnessOfInformationValid();
      }
      return false;
    }
    return true;
  }

  checkValidityForSubmitButton(): void {
    this.isSubmitDisabled = this.isFormInvalid();
  }

  redirectToProducts(): void {
    this.commonService.takeFromRequestOne = true;
    this.submitFormData(true);
  }

  private shouldShowAsDraft(): boolean {
    const powerConnection = this.localStorageService.getItem('power_connection');
    const powerConnectionChanged = this.localStorageService.getItem('power_connection_changed') === 'true';
    const isMainsConnection = this.currentInstallationFlow === this.installationFlowType.MainsConnection;
    const showTempRegistration = this.environmentService.showTempConnectionRegistrationForNewMains;
    const tempConnectionRequired = (this.applicationData as GridConnectionData).powergridcon?.is_temp_connection_less30_required;
    const hasTechnicianId = (this.applicationData as GridConnectionData).powergridcon?.technician_bdew_id;
    const requestCreated = (this.applicationData as GridConnectionData).sk_status == 'created';

    return (
      !this.isTechnician &&
      isMainsConnection &&
      showTempRegistration &&
      tempConnectionRequired &&
      hasTechnicianId &&
      !powerConnection?.tempPowerReportConfirmed &&
      (requestCreated || powerConnectionChanged) //https://github.com/bittner-krull/gop-web/issues/2286#issuecomment-3531919385
    );
  }

  private updateApplication() {
    const submitRequestObject: UpdateApplicationStatusRequest = {
      comment: this.documents.get('comments')?.value || '',
      desired_date: this.selectedDate ? this.commonService.parseDateForSaving(this.selectedDate) : '',
      building_con_from: this.connectionDate ? this.commonService.parseDateForSaving(this.connectionDate) : '',
      sk_status: this.shouldShowAsDraft() ? 'draft' : 'submitted',
      technical_conditions_met: this.technicalConditionsMetCheckbox ? '1' : '0',
      ...(this.showInstallationComment && {
        installation_comment: this.documents.get('installationComment')?.value || '',
      }),
    };
    if (
      this.isGasFacilityAvailable &&
      [this.installationFlowType.NewInstallation, this.installationFlowType.UpdateInstallation].includes(this.currentInstallationFlow)
    ) {
      submitRequestObject.chimney_sweeper_id = this.documents.get('chimneySweep')?.value?.chimney_sweeper_id;
    }

    if (this.showContactPersonOnDocumentsPage) {
      submitRequestObject.contact_person = this.documents.value.contactPerson as ContactPerson;
    }

    const applicationId = this.localStorageService.getItem('application_id') || '';
    const urlSegment: string =
      this.currentInstallationFlow === this.installationFlowType.NewInstallation ||
      this.currentInstallationFlow === this.installationFlowType.UpdateInstallation ||
      this.currentInstallationFlow === this.installationFlowType.FeedInSystem ||
      this.currentInstallationFlow === this.installationFlowType.SiteElectricityMeterdata
        ? UrlSegments.InstallationApplication
        : UrlSegments.GridConnectionApplication;

    return this.communicationService.updateData(`${urlSegment}${applicationId}`, submitRequestObject);
  }

  private handleSuccessResponse(addMore: boolean, response: UpdateApplicationStatusResponse) {
    this.isLoading = false;
    this.submitService.setMessage(MessageType.REQUEST_SUBMISSION);
    if (this.commonService.takeFromRequestOne && addMore) {
      this.router.navigate(['/panel']);
    } else {
      this.router.navigate(['/submitted']);
    }
    this.errorService.throwErrorIfFailure(response, true);
  }

  private handleErrorResponse(error: any) {
    this.isLoading = false;
    this.submitService.setMessage(MessageType.ERROR);
    this.router.navigate(['/submitted']);
    this.errorService.throwErrorIfFailure(error, true);
  }

  private updateExistingDocuments(): void {
    this.existingDocuments.forEach((document: Document) => {
      const otherDocument = this.documentTypes.filter(item => item.value === 'other')[0];
      if (document.sk_document_type !== otherDocument.value) {
        this.documents.controls[document.sk_document_type]?.setValue(document.filename || document.fileName);
        this.documentIds[document.sk_document_type] = document.document_id;
      } else {
        (this.documents.get('items') as FormArray).push(
          this.formBuilder.group({
            documentName: new FormControl({ value: document.name, disabled: true }),
            fileName: document.filename || document.fileName,
          })
        );
        this.documentIds[(this.documents.get('items') as FormArray).length - 1] = document.document_id;
      }
    });
  }

  private updateExistingSpecialConsumerDocuments(): void {
    this.existingDocuments
      .filter(d => ['pv_device_consumer', 'bhkw_kwk_device_consumer', 'storage_consumer'].includes(d.sk_document_type))
      .forEach((document: Document) => {
        const controlName = document.name;
        this.documents.controls[controlName]?.setValue(document.filename || document.fileName);
        this.documentIds[controlName] = document.document_id;
      });
  }

  private checkForTransformerCheckbox(): boolean {
    const allMeters: PowerMeterData[] = (this.applicationData as InstallationApplicationData).powerinstallation?.meter;
    let isTransformerProvidedByCustomer = false;
    if (allMeters.length) {
      allMeters.forEach(item => {
        isTransformerProvidedByCustomer = isTransformerProvidedByCustomer || item.transducer_customerprovided === '1';
      });
    }
    return isTransformerProvidedByCustomer;
  }

  private prepareDocumentsForm(applicationType: 'connection' | 'installation' | 'drrCcd'): void {
    this.documents = this.formBuilder.group({
      items: this.formBuilder.array([]),
    });

    this.appendInstallationFormControls();
    this.appendFeedInSystemFormControls();
    this.appendConversionToGasFormControls();
    this.appendSiteElectricityMeterdataFormControls();
    this.appendConnectionInstallationFlowFormControls();
    this.appendDrrCcdFormControls();

    if (applicationType === 'connection') {
      this.appendSpecialConsumerFormControlsForConnectionApplication(
        (this.applicationData as GridConnectionData).powergridcon.specialconsumer
      );
    } else if (applicationType === 'installation') {
      const facilities = (this.applicationData as InstallationApplicationData).powerinstallation?.facility;
      const flatSpecialConsumers =
        facilities?.reduce((acc, facility) => {
          return acc.concat(facility.specialconsumer);
        }, []) ?? [];

      this.appendSpecialConsumerFormControlsForInstallationApplication(flatSpecialConsumers);
    } else if (applicationType === 'drrCcd') {
    } else {
      throw `Unexpected application type: ${applicationType}`;
    }

    if (this.currentInstallationFlow === this.installationFlowType.ConversionToGas && this.showPlanWithEntryForConversionToGas) {
      this.documents = this.formBuilder.group({
        ...this.documents.controls,
        floor_plan: new FormControl({ value: '', disabled: true }),
      });
    }

    if (this.isSiteElectricityRequired) {
      this.documents = this.formBuilder.group({
        ...this.documents.controls,
        site_electricity_document: new FormControl({ value: '', disabled: true }, [Validators.required]),
      });
    }
    if (this.isBasementAvailable) {
      this.documents = this.formBuilder.group({
        ...this.documents.controls,
        floor_plan_basement: new FormControl({ value: '', disabled: true }, [Validators.required]),
      });
    }
    if (this.environmentService.showWaterRegistryDocument && (this.applicationData as GridConnectionData).site_water_required === '1') {
      this.documents = this.formBuilder.group({
        ...this.documents.controls,
        drinking_water_registration: new FormControl({ value: '', disabled: true }, [Validators.required]),
      });
    }
    if (this.isCustomerPowerAttorneyVisible) {
      this.documents = this.formBuilder.group({
        ...this.documents.controls,
        customer_power_of_attorney: new FormControl({ value: '', disabled: true }, [Validators.required]),
      });
    }

    this.updateExistingDocuments();
    this.updateExistingSpecialConsumerDocuments();
    this.items = this.documents.get('items') as FormArray;
    this.selectedDate = '';
    this.connectionDate = '';
    this.checkValidityForSubmitButton();
    this.documents.valueChanges.subscribe(() => this.checkValidityForSubmitButton());

    this.onDocumentFormInit.emit(this.documents);
  }

  onContactPersonInit(contactPersonForm: FormGroup) {
    this.documents.addControl('contactPerson', contactPersonForm);
    this.cd.detectChanges();
  }

  onDocumentUpdated(data: { documentId: number; controlName: string }) {
    this.documentIds[data.controlName] = data.documentId;
  }

  private appendSpecialConsumerFormControlsForConnectionApplication(powerConsumers: PowerSpecialConsumerData[]) {
    if (!powerConsumers) return;

    const powerConsumersDetails = powerConsumers.map(c => ({
      consumerId: c.specialconsumer_id,
      consumerType: c.sk_specialconsumer_type,
      consumerTypeTmp: c.sk_tmp_specialconsumer_type,
    }));

    this.appendSpecialConsumerFormControls(powerConsumersDetails);
  }

  private appendSpecialConsumerFormControlsForInstallationApplication(powerConsumers: any[]) {
    if (!powerConsumers) return;

    const powerConsumersDetails = powerConsumers.map(c => ({
      consumerId: c.specialconsumer_id,
      consumerType: c.sk_special_consumer_type,
      consumerTypeTmp: null,
    }));

    this.appendSpecialConsumerFormControls(powerConsumersDetails);
  }

  private appendSpecialConsumerFormControls(
    specialConsumers: { consumerType: string; consumerTypeTmp: string | null; consumerId: string }[]
  ) {
    const trackedTypes = ['pv_device_consumer', 'bhkw_kwk_device_consumer', 'storage_consumer'];

    for (const powerConsumer of specialConsumers) {
      let typeWithDocument: string | null = null;

      if (trackedTypes.includes(powerConsumer.consumerType)) {
        typeWithDocument = powerConsumer.consumerType;
      } else if (powerConsumer.consumerTypeTmp !== null && trackedTypes.includes(powerConsumer.consumerTypeTmp)) {
        typeWithDocument = powerConsumer.consumerTypeTmp;
      }

      if (typeWithDocument) {
        const controlName = `special_device_${typeWithDocument}_${powerConsumer.consumerId}`;
        this.documents.addControl(controlName, new FormControl('', [Validators.required]));
        this.powerConsumerDocumentDetails.push({ documentType: typeWithDocument, controlName: controlName });
      }
    }
  }

  private addControl(name: string, validators = [Validators.required], value: string = '', disabled = true) {
    this.documents.addControl(
      name,
      new FormControl(
        {
          value,
          disabled,
        },
        validators
      )
    );
  }

  private appendConnectionInstallationFlowFormControls() {
    if (
      ![InstallationFlowType.MainsConnection, InstallationFlowType.ChangeHouseConnection, InstallationFlowType.TemporaryConnection].find(
        flowType => flowType === this.currentInstallationFlow
      )
    ) {
      return;
    }

    this.documents.addControl('comments', new FormControl(''));

    const role = this.localStorageService.getItem('role');
    if (this.environmentService.showSitePlanDocument || this.currentInstallationFlow === this.installationFlowType.MainsConnection) {
      const isSitePlanRequired =
        (this.environmentService.sitePlanDocumentRequiredForChangeHouseConnection &&
          this.currentInstallationFlow === this.installationFlowType.ChangeHouseConnection) ||
        (this.environmentService.sitePlanDocumentRequiredForNewMainsConnection &&
          this.currentInstallationFlow === this.installationFlowType.MainsConnection) ||
        (this.environmentService.sitePlanDocumentRequiredForNewMainsConnectionElectricity &&
          this.currentInstallationFlow === this.installationFlowType.MainsConnection &&
          this.isPowerFacilityAvailable) ||
        (this.environmentService.sitePlanDocumentRequiredForTemporaryHouse &&
          this.currentInstallationFlow === this.installationFlowType.TemporaryConnection);

      if (!this.connectionInstallationDocumentsConfig.hide_site_plan) {
        const sitePlanValidators =
          isSitePlanRequired &&
          !this.environmentService.planDocumentsNotRequiredForRoles.find(
            roleWithoutRequiredSitePlan => roleWithoutRequiredSitePlan === role
          ) &&
          this.isSitePlanDocumentVisible
            ? [Validators.required]
            : [];
        this.addControl('site_plan', sitePlanValidators);
      }
    }

    if (
      (this.environmentService.showFloorPlanFileUpload || this.currentInstallationFlow !== this.installationFlowType.TemporaryConnection) &&
      !this.environmentService.hideFloorPlanFileUpload
    ) {
      let floorPlanValidators = [];

      if (
        this.currentInstallationFlow === this.installationFlowType.MainsConnection &&
        this.environmentService.floorPlanDocumentValidationStrategyForNewMains === 'custom_1'
      ) {
        const gridConnectionData = this.applicationData as GridConnectionData;
        const installationLocationType =
          this.powerConnectionInstallationLocationType ?? gridConnectionData.powergridcon?.installation_location_type;
        const isOptional = installationLocationType === 'meter_connection_column' || installationLocationType === 'other';
        floorPlanValidators = isOptional ? [] : [Validators.required];
      } else {
        const isFloorPlanRequired =
          (this.environmentService.floorPlanDocumentRequiredForChangeHouseConnection &&
            this.currentInstallationFlow === this.installationFlowType.ChangeHouseConnection &&
            this.currentSelectionType !== 'reallocation') ||
          this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
          (this.environmentService.floorPlanDocumentRequiredForTemporaryHouse &&
            this.currentInstallationFlow === this.installationFlowType.TemporaryConnection);

        floorPlanValidators =
          this.floorPlanDocumentRequired &&
          isFloorPlanRequired &&
          !this.environmentService.planDocumentsNotRequiredForRoles.find(
            roleWithoutRequiredSitePlan => roleWithoutRequiredSitePlan === role
          ) &&
          this.isFloorPlanDocumentVisible
            ? [Validators.required]
            : [];
      }

      this.addControl('floor_plan', floorPlanValidators);
    }

    if (this.environmentService.showOrdnanceFileUpload && this.currentInstallationFlow === this.installationFlowType.TemporaryConnection) {
      this.addControl('ordonance_clearence');
    }

    if (this.environmentService.licenseAgreementFile && this.jurisdictionService.thirdPartyAffected === '1') {
      this.addControl('license_agreement');
    }

    if (this.environmentService.showProofOfPropertyOwnerDocument && !this.jurisdictionService.isApplicantLandowner) {
      this.addControl('proof_of_landowner');
    }

    if (this.environmentService.showApprovalEmptyTubeDocument && this.jurisdictionService.isInterestInFibreOptics) {
      this.addControl('approval_empty_pipe');
    }

    if (
      this.currentInstallationFlow !== this.installationFlowType.TemporaryConnection &&
      this.environmentService.showCurrentAccountDocument &&
      this.isPowerFacilityAvailable
    ) {
      this.addControl('current_account');
    }

    if (this.currentInstallationFlow === this.installationFlowType.MainsConnection && this.showExcerptOrOverviewPlanDocument) {
      const isRequired = !this.environmentService.planDocumentsNotRequiredForRoles.find(
        roleWithoutRequiredSitePlan => roleWithoutRequiredSitePlan === role
      );

      this.addControl('excerpt_or_overview_plan', isRequired ? [Validators.required] : []);
    }
  }

  private appendInstallationFormControls() {
    if (
      this.currentInstallationFlow !== this.installationFlowType.NewInstallation &&
      this.currentInstallationFlow !== this.installationFlowType.UpdateInstallation
    ) {
      return;
    }

    if (this.environmentService.showCommentField) {
      this.documents.addControl('comments', new FormControl(''));
    }

    if (this.showInstallationComment) {
      this.documents.addControl('installationComment', new FormControl(''));
    }
    if (this.environmentService.showChimneySweepers && this.isGasFacilityAvailable) {
      this.getChimneySweeperDetails();
    }
  }

  private appendDrrCcdFormControls() {
    if (this.currentInstallationFlow !== this.installationFlowType.ConsumptionDevices) {
      return;
    }

    this.documents.addControl('comments', new FormControl(''));
  }

  private appendFeedInSystemFormControls() {
    if (this.currentInstallationFlow !== this.installationFlowType.FeedInSystem) {
      return;
    }
    const selectedChangeSubtype = this.localStorageService.getItem('selected_change_type');

    this.documents = this.formBuilder.group({
      ...this.documents.controls,
      comments: new FormControl(''),
    });

    if (this.show.data_sheet_generating_unit) {
      this.documents.addControl('data_sheet_modules', new FormControl({ value: '', disabled: true }, [Validators.required]));
    }

    if (this.show.data_sheet_modules) {
      this.documents.addControl('data_sheet_generating_unit', new FormControl({ value: '', disabled: true }, [Validators.required]));
    }

    if (this.show.overview_plan_single_pole) {
      this.documents.addControl(
        'overview_plan_single_pole',
        new FormControl({ value: '', disabled: true }, this.requiredOverviewPlanSinglePoleDocument ? [Validators.required] : [])
      );
    }

    if (this.show.pole_circuit_diagram_1) {
      this.documents.addControl('pole_circuit_diagram_1', new FormControl({ value: '', disabled: true }, [Validators.required]));
    }

    if (this.show.unit_certificate) {
      this.documents.addControl(
        'unit_certificate',
        new FormControl({ value: '', disabled: true }, this.requiredUnitCertificateDocument ? [Validators.required] : [])
      );
    }

    if (this.show.na_protection_certificate) {
      this.documents.addControl(
        'na_protection_certificate',
        new FormControl({ value: '', disabled: true }, this.requiredNaProtectionCertificateDocument ? [Validators.required] : [])
      );
    }

    if (this.show.vde_documents) {
      this.documents.addControl(
        'vde_documents',
        new FormControl({ value: '', disabled: true }, this.requiredVdeDocument ? [Validators.required] : [])
      );
    }

    if (this.show.site_plan && (this.environmentService.showSitePlanDocument || selectedChangeSubtype !== 'reallocation')) {
      this.addControl('site_plan', this.required.site_plan ? [Validators.required] : []);
    }

    if (this.show.power_of_attorney_1) {
      this.documents.addControl(
        'power_of_attorney_1',
        new FormControl('', [...(this.required.power_of_attorney_1 ? [Validators.required] : [])])
      );
    }

    if (this.show.e_1_application) {
      this.documents.addControl('e_1_application', new FormControl('', [...(this.required.e_1_application ? [Validators.required] : [])]));
    }

    if (this.show.e_2_data_sheet) {
      this.documents.addControl('e_2_data_sheet', new FormControl('', [...(this.required.e_2_data_sheet ? [Validators.required] : [])]));
    }

    if (this.show.e_3_memory_data) {
      this.documents.addControl('e_3_memory_data', new FormControl('', [...(this.required.e_3_memory_data ? [Validators.required] : [])]));
    }

    if (this.show.e_4_uniform_certificate) {
      this.documents.addControl(
        'e_4_uniform_certificate',
        new FormControl('', [...(this.required.e_4_uniform_certificate ? [Validators.required] : [])])
      );
    }

    if (this.show.e_6_certificate_for_network) {
      this.documents.addControl(
        'e_6_certificate_for_network',
        new FormControl('', [...(this.required.e_6_certificate_for_network ? [Validators.required] : [])])
      );
    }

    if (this.show.e_7_requirements_for_test_report) {
      this.documents.addControl(
        'e_7_requirements_for_test_report',
        new FormControl('', [...(this.required.e_7_requirements_for_test_report ? [Validators.required] : [])])
      );
    }

    if (this.show.b_11_overview_circuit_diagram) {
      this.documents.addControl(
        'b_11_overview_circuit_diagram',
        new FormControl('', [...(this.required.b_11_overview_circuit_diagram ? [Validators.required] : [])])
      );
    }

    if (this.show.registration_for_network_connection) {
      this.documents.addControl(
        'registration_for_network_connection',
        new FormControl('', [...(this.required.registration_for_network_connection ? [Validators.required] : [])])
      );
    }

    if (this.show.site_plan_or_area_map) {
      this.documents.addControl(
        'site_plan_or_area_map',
        new FormControl('', this.required.site_plan_or_area_map ? [Validators.required] : [])
      );
    }

    if (this.show.proof_of_conformity_certificates_modules) {
      this.documents.addControl(
        'proof_of_conformity_certificates_modules',
        new FormControl('', [...(this.required.proof_of_conformity_certificates_modules ? [Validators.required] : [])])
      );
    }

    if (this.show.proof_of_conformity_certificates_storage) {
      this.documents.addControl(
        'proof_of_conformity_certificates_storage',
        new FormControl('', [...(this.required.proof_of_conformity_certificates_storage ? [Validators.required] : [])])
      );
    }

    if (this.show.measuring_concept || this.showUploadAltMeasuringConcept) {
      this.documents.addControl(
        'measuring_concept',
        new FormControl('', [...(this.required.measuring_concept || this.showUploadAltMeasuringConcept ? [Validators.required] : [])])
      );
    }

    if (this.show.e_5_test_report) {
      this.documents.addControl('e_5_test_report', new FormControl('', [...(this.required.e_5_test_report ? [Validators.required] : [])]));
    }

    if (this.show.e_8_commissioning_protocol) {
      this.documents.addControl(
        'e_8_commissioning_protocol',
        new FormControl('', [...(this.required.e_8_commissioning_protocol ? [Validators.required] : [])])
      );
    }

    if (this.show.ground_protocol) {
      this.documents.addControl('ground_protocol', new FormControl('', [...(this.required.ground_protocol ? [Validators.required] : [])]));
    }
  }

  private appendConversionToGasFormControls() {
    if (this.currentInstallationFlow !== this.installationFlowType.ConversionToGas) {
      return;
    }

    if (this.showSitePlanDocumentForConversionToGas) {
      this.addControl('site_plan', []);
    }

    this.documents.addControl('comments', new FormControl(''));

    if (this.showExcerptOrOverviewPlanDocument) {
      this.addControl('excerpt_or_overview_plan');
    }
  }

  private appendSiteElectricityMeterdataFormControls() {
    if (this.currentInstallationFlow !== this.installationFlowType.SiteElectricityMeterdata) {
      return;
    }

    this.addControl('site_plan', []);
    this.addControl('floor_plan', []);
    this.documents.addControl('comments', new FormControl(''));

    if (JSON.parse((this.applicationData as InstallationApplicationData).powerinstallation?.facility[0]?.crane_in_place ?? 'false')) {
      this.addControl('crane_con_with_electric_drive');
    }

    if (this.checkForTransformerCheckbox()) {
      this.addControl('inspection_sticker');
    }
  }

  private initialiseDates() {
    this.minDate = new Date();
    this.minBuildingConDate = new Date();
    let minDateCount: number;
    if (this.environmentService.desiredDate && this.currentInstallationFlow === this.installationFlowType.NewInstallation) {
      minDateCount = this.environmentService.minDescriptionDateMeterMounting;
    } else {
      minDateCount = this.environmentService.minDocumentDescriptionDate;
    }

    if (this.currentInstallationFlow === this.installationFlowType.MainsConnection && this.isHeatingFacilityAvailable) {
      minDateCount = this.environmentService.minHeatDescriptionDate || this.environmentService.minDocumentDescriptionDate;
    }

    if (this.environmentService.minDistrictHeatingDescriptionDate && this.isHeatingFacilityAvailable) {
      minDateCount = this.environmentService.minDistrictHeatingDescriptionDate;
    }

    const minBuildingConDateCount = this.environmentService.minBuildingConDate;
    if (minDateCount > 0) {
      this.minDate.setDate(this.minDate.getDate() + minDateCount);
    }

    if (minBuildingConDateCount > 0 && this.currentInstallationFlow === this.installationFlowType.TemporaryConnection) {
      this.minBuildingConDate.setDate(this.minBuildingConDate.getDate() + minBuildingConDateCount);
    }
  }

  private isMainsConnectionApprovalValid(): boolean {
    if (this.showMainsConnectionApproval && this.currentInstallationFlow === this.installationFlowType.MainsConnection) {
      return this.role === 'customer'
        ? this.gridConnectionContractCheckbox &&
            this.buildingIsClosedCheckbox &&
            this.freedomToBuildCheckbox &&
            this.sewageAndRainwaterClosureCheckbox &&
            this.houseEntriesCheckbox
        : this.isVerifiedByTechnician;
    } else {
      return true;
    }
  }

  private isCorrectnessOfInformationValid(): boolean {
    if (
      this.showMainsConnectionApproval &&
      (this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
        this.currentInstallationFlow === this.installationFlowType.ConversionToGas)
    ) {
      return this.correctnessOfInformationCheckbox;
    } else {
      return true;
    }
  }

  private setMandatoryCheckboxes(): void {
    if (this.isReadOnly) {
      this.gridConnectionContractCheckbox = true;
      this.buildingIsClosedCheckbox = true;
      this.freedomToBuildCheckbox = true;
      this.sewageAndRainwaterClosureCheckbox = true;
      this.houseEntriesCheckbox = true;
      this.showMainsConnectionApproval = true;
      this.isVerifiedByTechnician = true;
    }
  }

  private displaySampleDocuments(): void {
    this.isLoading = true;
    this.downloadCenterService.getAllExampleDocuments().subscribe(
      (response: ExampleDocumentResponse) => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(response, true);
        this.allSampleDocuments = {};
        response.document.forEach(item => {
          this.allSampleDocuments[item.sk_document_type] = item;
        });
      },
      error => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  public get floorPlanText(): string {
    return this.environmentService.showFloorPlanWithEntryText &&
      this.currentInstallationFlow === this.installationFlowType.TemporaryConnection
      ? 'documents.floor_plan_with_entry'
      : 'documents.floor_plan';
  }
}
